import { MatSnackBar, MatSnackBarRef, TextOnlySnackBar } from '@angular/material/snack-bar';
import { Store } from '@ngxs/store';
import { EventsEnum } from '../engine/models/events.enum';
import { Func } from './define-procedure';
import { HumanInterface } from '../engine/models/human.interface';
import { MessageEnum } from './models/message.enum';
import { Router } from '@angular/router';

declare const Human: HumanInterface;
type HumanCallback = Func<any, void>;

export class HumanWindowAPI {
  private static store: Store = null;
  private static snackBar: MatSnackBar = null;
  private static router: Router = null;

  static appVersion = '';

  static setStore(store: Store) {
    HumanWindowAPI.store = store;
  }

  static setSnackBar(snackBar: MatSnackBar) {
    HumanWindowAPI.snackBar = snackBar;
  }

  static setRouter(router: Router) {
    HumanWindowAPI.router = router;
  }

  static debug(message: string) {
    if (typeof Human !== 'undefined' && typeof Human.events !== 'undefined') {
      Human.events.fire(EventsEnum.NativeDebugMessage, message);
    }
  }

  static fire(eventName: EventsEnum, message: string) {
    Human.events.fire(eventName, message);
  }

  on(eventName: EventsEnum, callback: HumanCallback) {
    Human.events.on(eventName, callback);
  }

  send(procName: MessageEnum, params?: any) {
    let snackBarRef: MatSnackBarRef<TextOnlySnackBar> = null;
    let queryParams = {};
    switch (procName) {
      case MessageEnum.NativeErrorMessage:
        snackBarRef = HumanWindowAPI.snackBar.open(params, 'OK', {
          duration: 6000,
          verticalPosition: 'top',
        });
        snackBarRef.onAction().subscribe(() => {
          snackBarRef.dismiss();
        });
        break;
      case MessageEnum.NativeSetAppVersion:
        HumanWindowAPI.appVersion = params.appVersion;
        break;
      case MessageEnum.NativeRedirect:
        queryParams = JSON.parse(params.queryItems);
        HumanWindowAPI.router.navigate([params.url], { queryParams: queryParams });
        Human.events.fire(EventsEnum.NativeDebugMessage, 'sent redirect ' + params.queryItems);
        break;
      case MessageEnum.NativeReload:
        window.location.href = params.url;
        Human.events.fire(EventsEnum.NativeDebugMessage, 'sent reload ' + params.url);
        break;
      default:
        Human.events.fire(
          EventsEnum.NativeDebugMessage,
          'unprocessed HumanWindowAPI send ' + procName,
        );
    }
  }
}
